export { default } from './StaticPageTrianglesContainer'
